import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
export const OMITTED_ACTION_TYPES = [
// virtual action irrelevant to history
ActionTypes.GO_TO, ActionTypes.CLASSIC_VIRTUAL_ANCHORED_DELAY, ActionTypes.VIRTUAL_SCHEDULED_ENROLLMENT,
// extensions are not grouped together and are individually listed
ActionTypes.AUTOMATION_EXTENSION];
export const HISTORY_ACTION_TYPES = {
  ALL: 'ALL',
  ENROLLMENT: 'ENROLLMENT'
};